import { create } from "zustand"

type LoadingIndicatorState = {
  isOpen: boolean
  isDimmed: boolean
  showLoading: (isDimmed: boolean) => void
  hideLoading: () => void
}

export const useLoadingIndicatorStore = create<LoadingIndicatorState>(
  (set) => ({
    isOpen: false,
    isDimmed: false,
    content: null,
    showLoading: (isDimmed: boolean) => set({ isOpen: true, isDimmed }),
    hideLoading: () => set({ isOpen: false }),
  }),
)
